import React, { useEffect, useState } from 'react'
import translate from '../../../../../i18n/translate'
import { ReactComponent as AudioBtn } from '../../../../../assets/img/metaberry_ui/sound_on.svg'
import { getCurrentLangString } from '../../../../../i18n/initI18n'
import useSound from '../../../../views/MetaberryView/hooks/useSound'
import { getSoundAssistance } from '../../../../../services/settingsService'
import { Analysis } from '../../../../../services/analysisService'

const OnboardingIntroductionPanel5 = ({ handleButton, pathSchool }) => {
  const { renderSoundFXController, playSoundEffect } = useSound()
  const langCode = getCurrentLangString()
  const audioFile = 'intro05_' + langCode
  const [blueberroImage, setBlueberroImage] = useState()

  useEffect(() => {
    getSoundAssistance() && playSoundEffect(audioFile)
    setBlueberroImage(
      pathSchool
        ? `/assets/graphics/gamification/${pathSchool}/bb_happy_boy.svg`
        : null
    )
  }, [])

  const handleAudio = () => {
    Analysis.sendEvent(Analysis.EVENT.REQUEST_TEXT_TO_SPEECH, {
      type: 'onboarding'
    })

    Analysis.sendSegmentTrackEvent(Analysis.SEGMENT_EVENTS['TTS Clicked'], {
      object: 'onboarding',
      ui_element_id: 'onboarding_introduction_5',
      seed_id: undefined
    })

    playSoundEffect(audioFile)
  }

  return (
    <div
      className={` ${
        blueberroImage
          ? 'onboarding-panel--intro onboarding-white-design'
          : 'onboarding-panel-without-image'
      }`}
    >
      <div className="onboarding-panel__bb-image_new-popup">
        <img
          src={blueberroImage}
          alt=""
          className="onboarding-panel__bb-image__panel-5"
        />
      </div>
      <div className="onboarding-panel_text-container">
        {renderSoundFXController()}
        <AudioBtn className="onboarding-panel__audio" onClick={handleAudio} />
        <div
          className={` ${
            blueberroImage
              ? 'onboarding-panel__text-title__complete'
              : 'onboarding-panel__text-auto'
          }`}
          dangerouslySetInnerHTML={{
            __html: translate('onboarding_intro_text_5')
          }}
        ></div>
        <div
          className="onboarding-panel__button-purple-design onboarding-panel__button--inline onboarding-panel__button--with-margin"
          onClick={handleButton}
          data-testid="onboarding_intro_button_5"
        >
          {translate('onboarding_intro_button_5')}
        </div>
      </div>
    </div>
  )
}
export default OnboardingIntroductionPanel5
